import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
    ) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const url = state.url;
    if (this.authService.loggedIn()) {
      const currentUserType = localStorage.getItem('currentUserType');

      if ( // Users related auth-guard.
        url.search(/list-users/i) > 0 ||
        url.search(/adduser/i) > 0 ||
        url.search(/edituser/i) > 0
        ) {
        if((currentUserType == 'Admin' || currentUserType == 'VehicleOperator')) {
          return true;
        }
      } else if ( // Scooters related auth-guard.
        url.search(/list-scooters/i) > 0 ||
        url.search(/scooter-details/i) > 0 ||
        url.search(/addscooter/i) > 0 ||
        url.search(/editscooter/i) > 0
        ) {
        if((currentUserType == 'Admin' || currentUserType == 'VehicleOperator')) {
          return true;
        }
      } else if ( // Operations related auth-guard.
        url.search(/operations/i) > 0
        ) {
          if((currentUserType == 'Admin' || currentUserType == 'VehicleOperator')) {
            return true;
          }
      } else if ( //SwapStation/Charging related auth-guard.
        url.search(/list-swapstations/i) > 0
        ) {
        if((currentUserType == 'Admin' || currentUserType == 'SwapStationOperator')) {
          return true;
        }
      } else if ( // Common auth-guard i.e the one we want to display across every user type
        currentUserType == 'Admin' ||
        currentUserType == 'VehicleOperator' ||
        currentUserType == 'SwapStationOperator'
        ) {
        return true;
      } else {
        return false;
      }
    }
    // navigate to login page
    // this.router.navigate(['/auth/login']);
    // you can save redirect url so after authing we can move them back to the page they requested
    return false;
  }

}
